module.exports = __webpack_public_path__ + "img/6.89089065.jpg";